import styled, { css } from 'styled-components'

import { colors } from '../../../../styles/colors'

interface IStyledItemProps {
  disabled?: boolean
  active?: boolean
}

export const StyledItem = styled.div<IStyledItemProps>`
  display: block;
  color: ${colors.gray7};
  cursor: pointer;

  padding: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  font-family: Roboto, sans-serif;
  font-size: 14px;
  min-width: 116.99px;
  width: 100%;

  ${props =>
    props.active &&
    css`
      color: ${colors.blue};
      border-bottom: 3px solid ${colors.green};
      font-weight: 600;
    `};
`

export const StyledItemContent = styled.div<IStyledItemProps>`
  font-weight: 600;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props =>
    props.disabled &&
    css`
      cursor: none;
      font-weight: 400;
    `};
`
